import { handleResponse } from './handleResponse';
import { makeRequest } from './makeRequest';
import type { HFetchArgs, HResponse } from './types';

/**
 * This hfetch method supports the standardized Humaniz API response shape.
 * Do not extend support for other response shapes, instead update the API to return this standardized shape:
 *
 * SUCCESS
 * {
 *   status: 'success',
 *   data: T
 * }
 *
 * ERROR
 * {
 *   status: 'error',
 *   messages: string[]
 * }
 */
export const hFetch = async <T, B = undefined>(args: HFetchArgs<B>): Promise<HResponse<T>> => {
  const response = await makeRequest<B>(args);
  return await handleResponse<T>(response);
};
